module.exports = __webpack_public_path__ + "2d6dbea31f8ac89336669e93f2c1958a.svg";